import 'bootstrap';
import 'slick-carousel';
import './modules/burger-rotate.js';
import './modules/carousels.js';
import './modules/filters.js';

import $ from "jquery";

$(function () {

  $(".animate").each(function (i, obj) {
    var top_of_object = $(this).offset().top;
    var top_of_window = $(window).scrollTop();

    /* If the object is completely visible in the window, fade it it */
    if (top_of_window + (window.innerHeight + 100) >= top_of_object) {
      if ($(this).hasClass("animate__delay-1")) {
        $(this).delay(250).animate(
          {
            opacity: "1",
          },
          900
        );
      }
      if ($(this).hasClass("animate__delay-2")) {
        $(this).delay(500).animate(
          {
            opacity: "1",
          },
          900
        );
      }
      if ($(this).hasClass("animate__delay-3")) {
        $(this).delay(750).animate(
          {
            opacity: "1",
          },
          900
        );
      }
      if ($(this).hasClass("animate__delay-4")) {
        $(this).delay(1000).animate(
          {
            opacity: "1",
          },
          900
        );
      }
      if ($(this).hasClass("animate__delay-5")) {
        $(this).delay(1250).animate(
          {
            opacity: "1",
          },
          900
        );
      }
      if ($(this).hasClass("animate__delay-6")) {
        $(this).delay(1500).animate(
          {
            opacity: "1",
          },
          900
        );
      }
      if ($(this).hasClass("animate__delay-7")) {
        $(this).delay(1750).animate(
          {
            opacity: "1",
          },
          900
        );
      }
      if ($(this).hasClass("animate__delay-8")) {
        $(this).delay(2000).animate(
          {
            opacity: "1",
          },
          900
        );
      }
      if ($(this).hasClass("animate__delay-9")) {
        $(this).delay(2250).animate(
          {
            opacity: "1",
          },
          900
        );
      }
      if ($(this).hasClass("animate__delay-10")) {
          $(this).delay(2500).animate(
            {
              opacity: "1",
            },
            900
          );
        } else {
        // I've changed the functionality for the new portfolios to use CSS for animation instead
        if ($(this).hasClass("special-animate")) {
          $(this).addClass("animate-on");
        } else {
          $(this).animate(
            {
              opacity: "1",
            },
            900
          );
        }
      }
    }

    if (top_of_window + (window.innerHeight - 500) >= top_of_object) {
      if ($(this).hasClass("white-section") && $(this).is("section")) {
        $(
          ".sticky-nav-right .popout2-link .pop-out2 .tab .pop-text svg text"
        ).attr("fill", "#000");
      }
    }
  });

  /* Every time the window is scrolled ... */
  $(window).on("scroll", function () {
    /* Check the location of each desired element */
    $(".animate").each(function (i, obj) {
      top_of_object = $(this).offset().top;
      top_of_window = $(window).scrollTop();

      /* If the object is completely visible in the window, fade it it */
      if (top_of_window + (window.innerHeight + 100) >= top_of_object) {
        if ($(this).hasClass("animate__delay-1")) {
          $(this).delay(250).animate(
            {
              opacity: "1",
            },
            900
          );
        }
        if ($(this).hasClass("animate__delay-2")) {
          $(this).delay(500).animate(
            {
              opacity: "1",
            },
            900
          );
        }
        if ($(this).hasClass("animate__delay-3")) {
          $(this).delay(750).animate(
            {
              opacity: "1",
            },
            900
          );
        }
        if ($(this).hasClass("animate__delay-4")) {
          $(this).delay(1000).animate(
            {
              opacity: "1",
            },
            900
          );
        }
        if ($(this).hasClass("animate__delay-5")) {
          $(this).delay(1250).animate(
            {
              opacity: "1",
            },
            900
          );
        }
        if ($(this).hasClass("animate__delay-6")) {
          $(this).delay(1500).animate(
            {
              opacity: "1",
            },
            900
          );
        }
        if ($(this).hasClass("animate__delay-7")) {
          $(this).delay(1750).animate(
            {
              opacity: "1",
            },
            900
          );
        }
        if ($(this).hasClass("animate__delay-8")) {
          $(this).delay(2000).animate(
            {
              opacity: "1",
            },
            900
          );
        }
        if ($(this).hasClass("animate__delay-9")) {
          $(this).delay(2250).animate(
            {
              opacity: "1",
            },
            900
          );
        }
        if ($(this).hasClass("animate__delay-10")) {
            $(this).delay(2500).animate(
              {
                opacity: "1",
              },
              900
            );
          } else {
          // I've changed the functionality for the new portfolios to use CSS for animation instead
          if ($(this).hasClass("special-animate")) {
            $(this).addClass("animate-on");
          } else {
            $(this).animate(
              {
                opacity: "1",
              },
              900
            );
          }
        }
      }

      if (top_of_window + (window.innerHeight - 500) >= top_of_object) {
        if ($(this).hasClass("white-section") && $(this).is("section")) {
          $(
            ".sticky-nav-right .popout2-link .pop-out2 .tab .pop-text svg text"
          ).attr("fill", "#000");
        }
      }
    });

    $(".white-section").each(function (i, obj) {
        var top_of_object = $(this).offset().top;
        var bottom_of_object = top_of_object + $(this).outerHeight();
        var top_of_window = $(window).scrollTop();
        var bottom_of_window = top_of_window + $(window).height();
      
        if (bottom_of_object >= top_of_window && top_of_object <= bottom_of_window) {
          var $targetText = $(".sticky-nav-right .popout2-link .pop-out2 .tab .pop-text svg text");
          var bottom_of_target = $targetText.offset().top + $targetText.outerHeight();
      
          if (bottom_of_target >= top_of_object && bottom_of_target <= bottom_of_object) {

            $targetText.attr("fill", "#000");
          } else {
    
            $targetText.attr("fill", "#fff");
          }
        } else {
          $(this).find(".sticky-nav-right .popout2-link .pop-out2 .tab .pop-text svg text").attr("fill", "#fff");
        }
      });

    $(".pink-infinite-line").each(function (i, obj) {
      var top_of_object = $(this).offset().top;
      var top_of_window = $(window).scrollTop();

      if (top_of_window + $(window).height() >= top_of_object) {
        var $element = $(this);
        setTimeout(function () {
          $element.addClass("full-width");
        }, 1000);
      }
    });
  });
});